export type BrandId = 'sgs' | 'abb';

/** Session flag so a localhost `?brand=` preview survives in-app navigation. */
export const BRAND_PREVIEW_STORAGE_KEY = 'portal-brand-preview';

const ABB_HOST = 'portal-abb.com';

export function isAbbHostname(hostname: string): boolean {
  const host = hostname.trim().toLowerCase();
  return host === ABB_HOST || host.endsWith(`.${ABB_HOST}`);
}

export function isLocalHostname(hostname: string): boolean {
  const host = hostname.trim().toLowerCase();
  return host === 'localhost' || host === '127.0.0.1';
}

export function brandIdFromSearch(search: string): BrandId | null {
  const value = new URLSearchParams(search).get('brand')?.trim().toLowerCase();
  if (value === 'abb' || value === 'sgs') {
    return value;
  }
  return null;
}

/**
 * `*portal-abb.com` uses ABB branding. Every other host, including
 * `*portal-sgs.com`, uses SGS. On localhost, `?brand=abb` or `?brand=sgs`
 * selects a preview and `storedBrand` keeps that choice after navigation.
 */
export function resolveBrandId(
  hostname: string,
  search = '',
  storedBrand: string | null = null
): BrandId {
  if (isAbbHostname(hostname)) {
    return 'abb';
  }

  if (isLocalHostname(hostname)) {
    const fromSearch = brandIdFromSearch(search);
    if (fromSearch) {
      return fromSearch;
    }
    if (storedBrand === 'abb' || storedBrand === 'sgs') {
      return storedBrand;
    }
  }

  return 'sgs';
}
